import Gallery from "webPage/Gallery";

const SLIDER_INTERVAL = 5 * 1000;

export default function handleCaseStudyStatsGalleries() {
    let $elements = $('.js-case-study-gallery');
    if ($elements.length > 0) {
        $elements.each(function () {
            handleCaseStudyStatsGallery($(this));
        });
    }
}

function handleCaseStudyStatsGallery($element) {
    let gallery = new Gallery($element, {
        itemClass: "case-study-stats-gallery__item",
        animationDuration: 400,
    });

    gallery.on('transitionStart', ({from, to}) => {
        resetCountUpElements(gallery.getItem(to));
    }).on('transitionEnd', ({from, to}) => {
        resetCountUpElements(gallery.getItem(from));

        setTimeout(() => {
            startCountUpElements(gallery.getItem(to));
        }, 600);
    });

    let $parent = $element.parents('.a:not(.a--play)').last();
    if ($parent.length > 0) {
        $parent.on('animation-start', ()=> {
           setTimeout(() => {
               gallery.getItem(0).addClass('case-study-stats-gallery__item--active');
               autoPlayGallery(gallery, SLIDER_INTERVAL);
           }, 800);
        });
    } else {
        setTimeout(() => {
            gallery.getItem(0).addClass('case-study-stats-gallery__item--active');
            autoPlayGallery(gallery, SLIDER_INTERVAL);
        }, 800);
    }
}

function resetCountUpElements($element) {
    let $countUpElements = $element.find('.js-count-up');

    if ($countUpElements.length > 0) {
        $countUpElements.each(function () {
            let $this = $(this);
            let countUp = $this.data('countUp');

            if (typeof countUp !== 'undefined') {
                countUp.reset();
            }
        });
    }
}

function startCountUpElements($element) {
    let $countUpElements = $element.find('.js-count-up');

    if ($countUpElements.length > 0) {
        $countUpElements.each(function () {
            let $this = $(this);
            let countUp = $this.data('countUp');

            if (typeof countUp !== 'undefined') {
                countUp.start();
            }
        });
    }
}

function autoPlayGallery(gallery, interval) {
    if (gallery.timeout) {
        clearTimeout(gallery.timeout);
    }

    gallery.timeout = setTimeout(() => {
        gallery.navigate('forwards');
        autoPlayGallery(gallery, SLIDER_INTERVAL);
    }, interval);
}